var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEthG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49918 5.09335e-07C4.56339 -0.000103569 4.62672 0.0157444 4.68407 0.0462653C4.74141 0.0767861 4.79117 0.121125 4.82931 0.175703L8.48853 5.42427L4.49918 6.82296L0.50983 5.42427L4.17069 0.175703C4.20867 0.12136 4.25816 0.077165 4.3152 0.046655C4.37224 0.0161449 4.43525 0.000167178 4.49918 5.09335e-07ZM0.500819 6.55984L4.17069 11.824C4.20876 11.8786 4.25843 11.9229 4.3157 11.9535C4.37298 11.9841 4.43624 12 4.50041 12C4.56458 12 4.62784 11.9841 4.68511 11.9535C4.74239 11.9229 4.79206 11.8786 4.83012 11.824L8.5 6.55984L4.6622 7.9066C4.55738 7.94306 4.44426 7.94306 4.33944 7.9066L0.500819 6.55984Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthG);
export default __webpack_public_path__ + "static/media/icon_ethG.d4782ff660890ad1b5e822dcf4de5c26.svg";
export { ForwardRef as ReactComponent };